/**
 * @file Route: moodrange
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "layouts/main"
import { Header } from "components/Header/Info"
import collectionMosaicSliders from "components/Page/Collection/mosaics"
import { dataLayerDowload, dataLayerPurchase } from "components/Datalayer"
import { $, on, $all, forEach } from "@olmokit/dom"
import "components/Cover";
import "./index.scss";

console.log("Route moodrange/index.js mounted.");

Header();
collectionMosaicSliders();

forEach($all("[download]"), el => {
  on(el, 'click', () => {
    const title = el.getAttribute('download')
    const collection = el.getAttribute('collection')
    const action = el.getAttribute('action')
    dataLayerDowload(collection, title, action)

    let selectedCategory = 'Mood'
    let selectedLook = 'Mood'
    const path = title.split('/');
    const fileName = path[path.length - 1]
    dataLayerPurchase(title, selectedCategory, selectedLook, fileName, 0)
  })
}); 